module.exports = __webpack_public_path__ + "static/uni_macarthur-d5e631440a901cd6926d48a1016e610c.png";